
import { mapMutations, mapState } from 'vuex'
import QRCodeDialog from './QRCodeDialog.vue'
import CookieSettingDialog from './cookieSetting.vue'
import footer from '@/modules/config/footer'

export default {
  components: { QRCodeDialog, CookieSettingDialog },
  data() {
    return {
      service: footer[this.$route.params.site].service,
      shareSubTitle: footer[this.$route.params.site].shareSubTitle,
      shareSubList: footer[this.$route.params.site].shareSubList,
      site: this.$route.params.site,
      lang: this.$route.params.lang,
      shareList: footer[this.$route.params.site].shareList,
    }
  },
  computed: {
    ...mapState({
      locale: (state) => state.locale,
      productMenus: (state) => state.productMenus,
    }),
    year() {
      return new Date().getFullYear()
    },
    support() {
      return require(`@/router/${this.site}/support.js`).default || {}
    },
    aboutUs() {
      return require(`@/router/${this.site}/aboutUs.js`).default || {}
    },
    helperList() {
      return [
        {
          il8nName: 'navs.logisticsService',
          id: 1,
          children: this.productMenus,
          // [
          //   {
          //     il8nName: 'modules.logisticsService.product',
          //     path: '/product#product',
          //     params: { hash: 'product' },
          //   },
          //   {
          //     il8nName: 'modules.logisticsService.increment',
          //     path: '/product#increment',
          //     params: { hash: 'increment' },
          //   },
          //   {
          //     il8nName: 'modules.logisticsService.addition',
          //     path: '/product#addition',
          //     params: { hash: 'addition' },
          //   },
          // ],
        },
        this.getChildrenPath(this.support),
        this.getChildrenPath(this.aboutUs),
      ]
    },
    getOtherSite() {
      if (process.client) {
        if (window.isHideSFbuy) {
          return (
            this.service
              .otherSite(this.lang)
              // 暂时过滤sfbuy
              .filter((it) => it.name !== 'modules.about.homePageTitles.sfBuy')
          )
        } else {
          return this.service.otherSite(this.lang)
        }
      } else {
        return []
      }
    },
  },
  mounted() {
    this.lang = this.$route.params.lang
  },
  methods: {
    ...mapMutations({
      setCookieTerms: 'SET_COOKIE_TERMS',
    }),
    routeChange(item) {
      this.$refs.QRCodeDialog.show(item.qrcode, item.tips)
    },
    // cookie 设置
    openCookieDialog() {
      this.setCookieTerms({
        title: this.$t('cookies.cookie'),
        show: true,
        type: 1,
      })
    },
    // goDetail(e) {
    //   this.$router.push({
    //     path:
    //       '/' +
    //       this.site +
    //       '/' +
    //       this.lang +
    //       '/solution_center/detail?case=' +
    //       e,
    //   })
    // },
    jumpDownload(str) {},
    // isMac() {
    //   const isMac = /macintosh|mac os x/i.test(navigator.userAgent)
    //   if (isMac) {
    //   } else {
    //   }
    // },
    getChildrenPath(menu) {
      menu.children.map((me) => {
        if (!me.path) {
          me.path = me.children[0].path || ''
        }
        return me
      })
      return menu
    },
  },
}
